// ─── German locale ────────────────────────────────────────────────────────────
const de = {
  // ── Navbar ──────────────────────────────────────────────────────────────────
  nav: {
    items: ["about", "experience", "projects", "skills", "contact"],
    labels: {
      about: "Über mich",
      experience: "Erfahrung",
      projects: "Projekte",
      skills: "Fähigkeiten",
      contact: "Kontakt",
    },
    logoAriaLabel: "Zur Startseite",
    hamburgerAriaLabel: "Menü umschalten",
    themeToggleDark: "Zum Tagesmodus wechseln",
    themeToggleLight: "Zum Nachtmodus wechseln",
    langToggleAriaLabel: "Sprache wechseln",
  },

  // ── HeroSection ─────────────────────────────────────────────────────────────
  hero: {
    role: "Data Scientist · KI-Ingenieur · Product Manager",
    headline1: "Adil",
    headline2: "Ibraheem Koyava",
    subtitle:
      "M.Sc.-Student für Business Intelligence & Data Analytics an der Hochschule Emden/Leer. 3+ Jahre als Associate Product Manager in EdTech und Medien — jetzt spezialisiert auf Agentic RAG und KI-Engineering.",
    cta: "Kontakt aufnehmen",
    stats: [
      { label: "Jahre Erf.", value: "4+" },
      { label: "Unternehmen", value: "3" },
      { label: "Sprachen", value: "4" },
    ],
    location: "Hamburg, Deutschland",
    scrollLabel: "SCROLLEN",
  },

  // ── AboutSection ────────────────────────────────────────────────────────────
  about: {
    tag: "// über mich",
    titleLine1: "Die Person",
    titleLine2: "hinter dem Code",
    bio1: "M.Sc.-Student für Business Intelligence & Data Analytics an der Hochschule Emden/Leer. 4+ Jahre als Associate Product Manager in EdTech und Medien — Features launchen, A/B-Tests durchführen und Roadmaps verantworten.",
    bio2: "Ich verbinde Produktinstinkt mit praxisorientiertem KI-Engineering: Entwicklung von Agentic-RAG-Pipelines, Fine-Tuning von LLMs und Bereitstellung von Full-Stack-KI-Anwendungen. Core Stack: Python, FastAPI, LangChain, Pinecone, React.",
    highlightLabel: "Kernkompetenzen",
    cards: [
      {
        title: "Ausbildung",
        desc: "M.Sc. Business Intelligence & Data Analytics — Hochschule Emden/Leer",
      },
      { title: "Standort", desc: "Hamburg, Deutschland" },
      { title: "Sprachen", desc: "Englisch · Deutsch · Malayalam · Tamil" },
      {
        title: "Schwerpunkte",
        desc: "Agentic RAG · LLM-Engineering · Product Management · KI-Anwendungen",
      },
    ],
  },

  // ── ExperienceSection ───────────────────────────────────────────────────────
  experience: {
    tag: "// beruflicher werdegang",
    titleLine1: "Berufliche",
    titleLine2: "Erfahrung",
  },

  // ── ProjectsSection ─────────────────────────────────────────────────────────
  projects: {
    tag: "// portfolio",
    titleLine1: "Ausgewählte",
    titleLine2: "Projekte",
    viewOnGitHub: "Auf GitHub ansehen",
  },

  // ── SkillsSection ───────────────────────────────────────────────────────────
  skills: {
    tag: "// technische fähigkeiten",
    title: "Mein Werkzeugkasten",
    certificationsLabel: "Zertifikate & Auszeichnungen",
    certsSubLabel: "Zertifikate",
    achievementsSubLabel: "Auszeichnungen",
  },

  // ── ContactSection ──────────────────────────────────────────────────────────
  contact: {
    tag: "// kontakt",
    titleLine1: "Lass uns",
    titleLine2: "zusammenarbeiten",
    description:
      "Offen für Kooperationen, Forschungsprojekte und interessante Probleme im Bereich KI-Engineering und Produktmanagement. Wohnhaft in Hamburg — offen für Remote- und Vor-Ort-Positionen.",
    labels: {
      email: "E-Mail",
      phone: "Telefon",
      github: "GitHub",
      linkedin: "LinkedIn",
      location: "Standort",
    },
  },

  // ── Footer ──────────────────────────────────────────────────────────────────
  footer: {
    builtWith: "Erstellt mit",
    by: "von Adil Ibraheem Koyava",
    copyright: "© 2026 · Hamburg, Deutschland",
  },

  // ── ChatWidget ──────────────────────────────────────────────────────────────
  chat: {
    headerTitle: "Frag Adil",
    headerSub: "RAG-KI-Assistent · meist sofort",
    welcomeText:
      "Hallo! Ich bin Adils KI-Assistent. Frag mich zu seiner Erfahrung, seinen Projekten oder Fähigkeiten.",
    placeholder: "Stell eine Frage über Adil...",
    faqLabel: "Häufig gefragt",
    faqChips: [
      "Was ist deine Berufserfahrung?",
      "Erzähl mir von deinen Projekten",
      "Welche Fähigkeiten hast du?",
    ],
    errorFallback: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    connectionError: "Verbindungsfehler. Bitte versuche es erneut.",
    retryBtn: "Erneut versuchen",
    typingAriaLabel: "KI tippt",
    messagesAriaLabel: "Chat-Nachrichten",
    dialogAriaLabel: "Chat mit Adils KI-Assistent",
    closeBtnAriaLabel: "Chat schließen",
    inputAriaLabel: "Nachricht eingeben",
    sendAriaLabel: "Nachricht senden",
    toggleOpenAriaLabel: "KI-Chat über Adil öffnen",
    toggleCloseAriaLabel: "Chat schließen",
    tooltip:
      "RAG-gestützter KI-Assistent, trainiert auf Adils Lebenslauf, Projekten und Fähigkeiten",
  },
};

export default de;
